// Lookup reads the persisted order, never the editor's unsaved form fields.
// Keep address identity distinct from unrelated order refreshes and media edits.
export const savedAccessAddressKey = order => JSON.stringify([
  order?.place_id || '', order?.recipient_street_address || '',
  order?.recipient_street_address_2 || '', order?.recipient_city || '',
  order?.recipient_state || '', order?.recipient_zip_code || '',
]);
